import { AnyObject, CurdDataSetConfig, FormFieldConfig, FormFieldType, UserJoint } from '../types';
import { toDateFormat } from '@mri/functions';

const filterFields: Array<FormFieldConfig<UserJoint>> = [
  {
    key: 'firstName',
    label: 'Nombre',
    type: FormFieldType.STRING,
    containerClass: 'col-md-6 col-12',
  },
  {
    key: 'lastName',
    label: 'Nombre',
    type: FormFieldType.STRING,
    containerClass: 'col-md-6 col-12',
  },
  {
    key: 'email',
    label: 'Correo electronico',
    type: FormFieldType.STRING,
    containerClass: 'col-12'
  },
  {
    key: 'profileIds',
    label: 'Perfiles',
    type: FormFieldType.OPTIONS_MULTIPLE,
    containerClass: 'col-md-6 col-12',
    optionsGateway: 'profiles',
    filterOptions: { type: 'profile' }
  },
  {
    key: 'permissions',
    label: 'Permisos',
    type: FormFieldType.OPTIONS_MULTIPLE,
    containerClass: 'col-md-6 col-12',
    optionsGateway: 'config/permissions',
    fillValue: (element) => ((((element as AnyObject) || {}).permissions || []) as Array<AnyObject>)
      .map(p => p?.key)
      .filter(p => p)
  }
];

export const userCurdDataSetConfig: CurdDataSetConfig<UserJoint> = {
  entityName: 'Usuario',
  collectionName: 'Users',
  gatewayUrl: 'users',
  baseBreadcrumb: 'users',
  form: {
    listRedirectUrl: 'console/user/list',
    fields: filterFields,
    handleObject: data => {

      const permissions = Array.isArray(data?.['permissions']) ? (data?.['permissions'] || []).filter(p => p).map(key => ({ key })) : [];
      return {
        ...data,
        permissions
      } as unknown as UserJoint;
    }
  },
  list: {
    pageConfig: {
      title: 'Lista de usuarios',
      breadcrumb: [
        {
          title: 'Usuarios',
          type: 'item',
          link: '/console/users/list'
        },
        {
          title: 'Lista',
          type: 'item',
          link: '/console/users/list',
          pageName: 'Vínculos de Usuarios'
        }
      ]
    },
    table: {
      columns: [
        {
          key: 'name', label: 'Nombre',
          getValue({ element }) {
            const { firstName, lastName } = element.user.contact || {};

            return `${firstName ?? 'No definido'} ${lastName ?? 'No definido'}`;
          }
        },
        {
          key: 'email', label: 'Correo electronico',
          getValue({ element }) {
            const { email } = element.user.contact || {};

            return email ?? 'No definido';
          }
        },
        {
          key: 'type', label: 'Vinculo con',
          getValue: ({ element }) => {
            return element.properties?.map(p => p.name).join(', ') || 'No tiene propiedades';
          }
        },
        { key: 'status', label: 'Estado', getValue: ({ element }) => element.accepted ? 'Acetado' : 'En espera' },
        { key: 'createdTime', label: 'Fecha de creación', getValue: ({ element }) => toDateFormat(element.createdTime) }
      ]
    },
    actionsKeys: ['create', 'edit', 'transfer', 'delete'],
    filter: filterFields,
    searchFilter: filterFields,
    extraActions: [
      {
        key: 'update-contact',
        label: 'Actualizar contacto',
        click: ({ selectedElements, component }) => {

          if (!component) return;
          if (!selectedElements?.length) return;

          const service = component.genericResourceSrv;

          return service.putElement(`users/${selectedElements[0]._id}/contact`, {});
        },
        inRow: true,
        onlyIcon: () => true,
        icon: 'fi fi-rs-phone-guide',
        disableWhen: ({ selectedElements }) => selectedElements?.length !== 1
      }
    ]
  },
  pages: ['list', 'create', 'edit']
};
